module.exports = __webpack_public_path__ + "static/media/delayed pin.ac4ca4ec.svg";